<template>
  <v-form ref="formValid" v-model="valid">
    <v-dialog v-model="dialog" width="600" dark>
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          dark
          class="add-bookmark elevation-2 mr-3 my-2"
          v-bind="attrs"
          v-on="on"
        >
          <img :src="require('@/assets/icons/filters/add.svg')" alt="Add bookmark">
          <span id="add-bookmark">{{ $t('device.filter.save_bookmark') }}</span>
        </v-chip>
      </template>
      <v-card class="dat-container">
        <v-card-title class="title pa-4 pl-11">{{ $t('device.filter.save_bookmark_title') }}</v-card-title>
        <v-divider />
        <v-card-text class="content py-7 px-12">
          <v-row class="d-flex flex-column" dense justify="center">
            <div class="mb-1 mt-4 file-name">{{ $t('device.filter.save_bookmark') }}</div>
            <v-text-field
              id="bookmark-name"
              v-model="bookmarkName"
              outlined
              dark
              dense
              hide-details="auto"
              :rules="[bookmarkName !== '' || $t('common.error.forms.inputs.validator.mandatory')]"
            />
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text class="pa-4 pr-10 text-right">
          <v-btn
            id="save-bookmark-cancel"
            class="cancel"
            dark
            rounded
            @click="close"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            id="save-bookmark-confirm"
            class="ctp-btn my-0"
            dark
            :disabled="bookmarkName === ''"
            @click="saveBookmark"
          >
            {{ $t('common.confirm') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <Notification
      :content="notificationContent"
      :type="notificationStatus"
      :isNotificationOpen="isNotificationOpen"
      @notificationClosed="closeNotification"
    />
  </v-form>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';
import useStore from '@/utils/store/common';
import Notification from '@/components/common/Notification/Notification.vue';

const store = useStore();

const dialog = ref(false);
const valid = ref(false);
const bookmarkName = ref('');

const notificationContent = ref('');
const notificationStatus = ref('');
const isNotificationOpen = ref(false);

const props = defineProps({
  filters: {
    type: Array as PropType<{ [key: string]: any }[]>,
    default: () => []
  }
});

function close() {
  dialog.value = false;
}

async function saveBookmark() {
  const mergedFilters = Object.assign({}, ...props.filters);
  const stringFilters = JSON.stringify(mergedFilters);
  const filters = { filterGroup: { filters: stringFilters, name: bookmarkName.value } };
  const res = await store.dispatch('groupManagement/createFilterGroup', filters);
  store.dispatch('groupManagement/fetchFilterGroups');
  dialog.value = false;
  notificationStatus.value = res.notificationStatus;
  notificationContent.value = res.notificationStatus;
  isNotificationOpen.value = true;
}

function closeNotification() {
  isNotificationOpen.value = false;
  notificationContent.value = '';
  notificationStatus.value = '';
}
</script>

<style lang="scss" scoped>
@import './styles/add-bookmark.scss';
</style>
